export const CustomYAxisLabel = ({ startingX, exponent }: any) => {
  if (exponent === 0) return null;
  return (
    <text x={startingX + 10} y={15} fontSize={14} fill="#666" fontWeight="bold">
      {" "}
      x10{" "}
      <tspan baselineShift="super" fontSize="10">
        {exponent}
      </tspan>
    </text>
  );
};
